<div class="radar-chart-container">
    <div id="chart" #chart>
        <div *ngIf="loading">Cargando ...</div>
    </div>
    
    <div class="chart-legend" *ngIf="!loading && showLegend && data && data.length > 0">
        <div class="legend-item" 
             *ngFor="let series of data; let i = index"
             [class.active]="!series.hidden"
             (click)="toggleSeries(i)">
            <span class="legend-dot" [style.background-color]="getSeriesColor(i)"></span>
            <span class="legend-text">{{ series.name }}</span>
        </div>
    </div>
</div>